









































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import MenuPO from "@/store/entities/basedata/menupo";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import TreeSelect from "@riophae/vue-treeselect";
@Component({
  components: { TreeSelect },
})
export default class CreateMenu extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean;
  menupo: MenuPO = new MenuPO();
  loading: boolean = false;
  created() {
    this.itemtree();
    this.menupo.isEnable = 1;
    this.menupo.parentId = 0;
    this.menupo.menuType = 3;
  }
  create() { }
  save() {
    (this.$refs.areaForm as any).validate(async (valid: boolean) => {
      if (valid) {
        this.loading = true;
        this.$store
          .dispatch({
            type: "menu/checkTagName",
            data: this.menupo,
          })
          .then((val) => {
            console.log(val)
            if (val != null && val > 0) {
              this.$Modal.info({
                title: this.L("Tips"),
                content: this.L("TagNameExist"),
              });
              this.loading = false;
              return;
            }
          })
          .catch((err) => {
            this.$Modal.info({
              title: this.L("Tips"),
              content: err,
            });
            this.loading = false;
            return;
          });
        await this.$store
          .dispatch({
            type: "menu/create",
            data: this.menupo,
          })
          .then((val) => {
            if (val.data.success == true) {
              this.$Modal.info({
                title: this.L("Tips"),
                content: this.L("Success"),
              });
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
        this.loading = false;
        (this.$refs.areaForm as any).resetFields();
        this.$emit("save-success");
        this.$emit("input", false);
      }
    });
  }
  cancel() {
    (this.$refs.areaForm as any).resetFields();
    this.$emit("input", false);
  }
  async itemtree() {
    await this.$store
      .dispatch("menu/getselectTree")
      .then((val) => {
        console.log(val)
        this.$data.optionsMechanism = val;
      })
      .catch((err) => {
        console.log(err);
      });
  }
  visibleChange(value: boolean) {
    if (!value) {
      this.$emit("input", value);
    }
  }
  areaRule = {
    tagName: [
      {
        required: true,
        message: this.L("TagCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    parentId: [
      {
        type: "number",
        required: true,
        message: this.L("FirstNodeCanNotEmpty"),
        trigger: "blur",
      },
    ],
    displayName: [
      {
        required: true,
        message: this.L("NameCanNotBeEmpty"),
        trigger: "blur",
      },
    ],
    sortCode: [
      {
        type: "number",
        required: true,
        message: this.L("CanNotBeEmpty"),
        trigger: "blur",
      },
    ],
  };
  data() {
    return {
      optionsMechanism: [],
      normalizer(node) {
        if (node.children && !node.children.length) {
          delete node.children;
        }
        return {
          id: node.id,
          label: node.label,
          children: node.children,
        };
      },
    };
  }
}
